import React, { useState, useEffect } from "react";

import "./DateRange.css";
import { notify } from "react-notify-toast";
import "./UserProfile.css";
import * as $ from 'jquery';

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber }  from 'react-phone-number-input'

import "react-datepicker/dist/react-datepicker.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { addDays } from "date-fns";
import { getCities, getCountries, getRegions, getStates } from "../../Helper";
import "./PersonalDetails.css";
import FormField from "../../Components/FormField/FormField";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormMultiSelect from "../../Components/FormField/FormMultiSelect";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import { Country, State, City }  from 'country-state-city';

//redux
import { connect } from "react-redux";
import { mobileStepperClasses } from "@mui/material";
import { API } from "../../API";

const moment = extendMoment(originalMoment);
const isNumeric = (value) => {
  return /^[0-9]*$/.test(value);
};

const APP_ID_HERE = 'APP_ID_HERE';
const APP_CODE_HERE = 'APP_CODE_HERE';

const cities = [
  { value: "Online", label: "Online" },
  { value: "Melbourne", label: "Melbourne" },
  { value: "Sydney", label: "Sydney" },
  { value: "Geelong", label: "Geelong" },
  { value: "Brisbane", label: "Brisbane" },
  { value: "Sunshine Coast", label: "Sunshine Coast" },
  { value: "Gold Coast", label: "Gold Coast" },
  { value: "Newcastle", label: "Newcastle" },
  { value: "Christchurch", label: "Christchurch" },
  { value: "Auckland", label: "Auckland" },
  { value: "Ballarat", label: "Ballarat" },
  { value: "Singapore", label: "Singapore" },
  { value: "Kuala Lumpur", label: "Kuala Lumpur" },
  { value: "George Town of Penang", label: "George Town of Penang" },
  { value: "Ipoh", label: "Ipoh" },
  { value: "Johor Bahru", label: "Johor Bahru" },
  { value: "Malacca City", label: "Malacca City" },
  { value: "Kota Kinabalu", label: "Kota Kinabalu" },
  { value: "Kuantan", label: "Kuantan" },
  { value: "Alor Setar", label: "Alor Setar" },
  { value: "Tawau", label: "Tawau" },
  { value: "Sandakan", label: "Sandakan" },
  { value: "Jakarta", label: "Jakarta" },
  { value: "Surabaya", label: "Surabaya" },
  { value: "Bandung", label: "Bandung" },
  { value: "Medan", label: "Medan" },
  { value: "Semarang", label: "Semarang" },
  { value: "Bekasi", label: "Bekasi" },
  { value: "Tangerang", label: "Tangerang" },
  { value: "Depok", label: "Depok" },
  { value: "Palembang", label: "Palembang" },
  { value: "South Tangerang", label: "South Tangerang" },
  { value: "Ho Chi Minh City", label: "Ho Chi Minh City" },
  { value: "Ha Noi", label: "Ha Noi" },
  { value: "Hai Phong", label: "Hai Phong" },
  { value: "Can Tho", label: "Can Tho" },
  { value: "Bien Hoa", label: "Bien Hoa" },
  { value: "Da Nang", label: "Da Nang" },
  { value: "Vung Tau", label: "Vung Tau" },
  { value: "Nha Trang", label: "Nha Trang" },
  { value: "Buon Ma Thuot", label: "Buon Ma Thuot" },
  { value: "Hue", label: "Hue" },

];

let currentCities=[];
// This is a demo API key that can only be used for a short period of time, and will be unavailable soon. You should rather request your API key (free)  from http://battuta.medunes.net/ 	
const BATTUTA_KEY="c87ad82811ea248a6ca140b3ca119f14";
  	// Populate country select box from battuta API
	let url="https://geo-battuta.net/api/country/all/?key="+BATTUTA_KEY+"&callback=?";
      
  	$.getJSON(url,function(countries)
  	{
      $('#country').select();
	    //loop through countries..
	    $.each(countries,function(key,country)
	    {
	        $("<option></option>")
	         				.attr("value",country.code)
	         				.append(country.name)
	                     	.appendTo($("#country"));
	       
	    }); 
	    // trigger "change" to fire the #state section update process
	    $("#country").trigger("change");
  	});
  	
const states = getStates();

const regions = getRegions();

const countries = getCountries();

const Cities = getCities();

class PersonalForm2 extends React.Component {
  constructor(props) {
    super(props);
    if(typeof(this.props.state.date_of_birth) === 'string') {
      this.props.state.date_of_birth = new Date(this.props.state.date_of_birth)
    }
    if (!props.user) {
      window.location = "/login";
    }
    this.state = {
      default_work_location: props.state.prefered_work_location
        ? props.state.prefered_work_location.map((item) => {
          return { value: item, label: item };
        })
        : "Please select",
      contact_number: props.user.contact_number,
      isMobileValid: false,
      showPopup: false,
      showConfirmNumber: false,
      cities_by_state: this.getCitiesByState(this.props.state?.country, this.props.state?.region) || []
    };  
  }

  onCountryChange = () => {
    console.log("onCountryChange");
    const countryCode =$("#country").val();
  
    // Populate country select box from battuta API
    url="https://geo-battuta.net/api/region/"+countryCode+"/all/?key="+BATTUTA_KEY+"&callback=?";

    $.getJSON(url,function(regions)
    {
      $("#region option").remove();
      //loop through regions..
      $.each(regions,function(key, region)
      {
        console.log("printing new regions");
          $("<option></option>")
                 .attr("value",region.region)
                  .append(region.region)
                    .appendTo($("#region"));
      });
      // trigger "change" to fire the #state section update process
      //  $("#region").select("update");
        $("#region").trigger("change");
    });
    this.props.handleStateChange("country", countryCode);
  }
  onRegionChange = () => {
    const countryCode=$("#country").val();
    const region=$("#region").val();
    // Populate country select box from battuta API
    url="https://geo-battuta.net/api/city/"+countryCode+"/search/?region="+region+"&key="+BATTUTA_KEY+"&callback=?";
    
    $.getJSON(url,function(Cities)
    {
      currentCities=Cities;
        var i=0;
        $("#city option").remove();
      
      //loop through regions..
      $.each(Cities,function(key, city)
      {
          $("<option></option>")
                   .attr("value",i++)
                   .append(city.city)
                  .appendTo($("#city"));
      });
      // trigger "change" to fire the #state section update process
      $("#city").trigger("change");
  
  });	
  this.props.handleStateChange("region", region);
}

  onCityChange = () =>{
    const currentIndex=$("#city").val();
    const currentCity=currentCities[currentIndex];
    const city=currentCity.city;
    const region=currentCity.region;
  //  const country=currentCity.country;
    const lat=currentCity.latitude;
    const lng=currentCity.longitude;
    $("#location").html('<i class="fa fa-map-marker"></i> <strong> '+city+"/"+region+"</strong>("+lat+","+lng+")");

    this.props.handleStateChange("city", city);
  }

  handleChangeNumber = () => {
    this.setState({
      showConfirmNumber: false,
      isMobileValid: false,
    });
    this.props.handleStateChange("contact_number_verified", false);
  };

  handleConfirmNumber = () => {
    const mobile = document.querySelector('#contact_number').value
    if (mobile) {
        if (isValidPhoneNumber(mobile)) {
            this.setState({
                showConfirmNumber: true,
                isMobileValid: false,
              })
        } else {
            notify.show('Invalid phone number')
        }
    } else {
        notify.show('Phone number required')
    }
  }


  handleCancelCode = () => {
    this.setState({ showPopup: false });
    this.handleChangeNumber();
  };

  handleShowPopUp = () => {
    this.setState({
      showPopup: !this.state.showPopup,
    });
  };

  handleRequestOTP = (event) => {
    event.preventDefault();
    const mobile = document.querySelector('#contact_number').value
    const email = this.props.state.email;
    this.setState({
      isMobileValid: false,
      showConfirmNumber: false,
    });

    API.requestOTP({
      params: {
        email: email,
        mobile: mobile.substring(1),
      }
    })
      .then((response) => {
        this.handleShowPopUp();
        window.auth_user_id = response.data.auth_user_id;
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  handleConfirmCode = () => {
    const codes = document.querySelector("#verifycode").value;
    if (isNumeric(codes)) {
      API.verifyOTP({
        params: {
          id: window.auth_user_id,
          token: codes,
          email: this.props.state.email,
        },
      })
        .then((response) => {
          this.handleShowPopUp();
          this.props.handleStateChange("contact_number_verified", true);
          // console.log(response);
          notify.show("Mobile number verified");
        })
        .catch((error) => {
          console.log(error);
          notify.show("Please enter the exact code sent to your phone");
        });
    } else {
      notify.show("Please enter numbers only");
    }
  };

  handleLocationDDL = (e) => {
    let locations = [];
    if (e) {
      locations = e.map((item) => {
        return item.value;
      });
    }
    // console.log(e);
    // console.log(locations);
    this.props.handleStateChange("prefered_work_location", locations);
  };

  getUserName = () => {
    var username = this.props.state.first_name.toUpperCase()
    if (this.props.state.last_name) {
      username += "_" + this.props.state.last_name[0]
    }

    return username
  }

  changeRegion = (e) => {
    let citiesOfState = this.getCitiesByState(this.props.state.country, e.target.value);
    this.setState({ cities_by_state: citiesOfState });
    this.props.handleFormFieldChange(e);
  }

  getCitiesByState = (country, region) => {
    const regions = [
      "BDG", "BNE", "BEX", "BEN", "BRY", "CMD", "CRY", "EAL", "ENF", "HCK", 
      "HMF", "HRY", "HRW", "HAV", "HIL", "HNS", "ISL", "LBH", "LEW", "MRT", 
      "NWM", "RDB", "RIC", "SWK", "STN", "TWH", "WFT", "WND"
    ];
    if(country == 'GB' && regions.includes(region)) {
      return [
        {
          countryCode : "GB",
          latitude : "51.50853000",
          longitude : "-0.12574000",
          name : "London",
          // stateCode : "ENG"
        }
      ];
    }
    return City.getCitiesOfState(country, region);
  }

  reRender = () => {
    this.forceUpdate()
  }

  render() {
    return (
      <>
        <div className="row">
          {/* TESTING BEFORE IMPLEMENTATION */}
          {/* <script src='https://cdn.jsdelivr.net/npm/places.js@1.16.4'></script> */}

          <div className="col-lg-6 col-md-12">
            <div className="auth-text-top mb-md-5">
              <FormField
                icon="account-circle"
                label="Username"
                id="username"
                name="Username"
                placeholder="Username"
                disabled
                value={this.getUserName()}
              />

              <FormField
                label="First Name"
                id="first_name"
                required
                placeholder="First Name"
                value={this.props.state.first_name}
                onChange={this.props.handleFormFieldChange}
              />

              <FormField
                label="Middle Name (Optional)"
                id="middle_name"
                placeholder="Middle Name"
                value={this.props.state.middle_name}
                onChange={this.props.handleFormFieldChange}
              />

              <FormField
                label="Last Name"
                id="last_name"
                required
                value={this.props.state.last_name}
                onChange={this.props.handleFormFieldChange}
                placeholder="Last Name"
              />

              <FormField
                label="Preferred Name (Optional)"
                id="preferred_name"
                value={this.props.state.preferred_name}
                onChange={this.props.handleFormFieldChange}
                placeholder="Please leave blank if your First Name and Preferred Name are the same"
              />

              <FormField
                icon="account-check"
                label="Email"
                type="email"
                id="email"
                disabled
                value={this.props.state.email}
                placeholder="Email"
              />

              <PhoneInput
                icon="phone"
                label="Contact Number"
                inputComponent={FormField}
                id="contact_number"
                required
                placeholder="Enter phone number"
                value={this.props.state.contact_number}
                onChange={this.props.handleNumberChange}
                defaultCountry="AU"
                international
                disabled={this.props.state.contact_number_verified}
                sideButton={
                  this.props.state.contact_number_verified
                    ? { label: "Change", onClick: this.handleChangeNumber }
                    : { label: "Verify", onClick: this.handleConfirmNumber }
                }
                header={
                  this.props.state.contact_number_verified ? (
                    <HoverIcon
                      icon="check circle"
                      color="green"
                      text="This contact number is verified!"
                    />
                  ) : (
                    <HoverIcon
                      icon="check circle"
                      color="grey"
                      text="This contact number is not verified yet!"
                    />
                  )
                }
              />
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="auth-text-top mb-5">
             {/* <FormDatePicker
                label="Date of Birth"
                id="date_of_birth"
                selected={this.props.state.date_of_birth}
                // placeholderText={new Date()
                //   .toLocaleDateString()
                //   .split(/\//)
                //   .join("-")}
                placeholderText="Please Select"
                showYearDropdown
                showMonthDropdown
                isClearable
                showPopperArrow={false}
                maxDate={addDays(new Date(), 0)}
                dropdownMode="select"
                dateFormatCalendar="MMMM"
                dateFormat="dd-MM-yyyy"
                yearDropdownItemNumber={10}
                scrollableYearDropdown
                onChange={this.props.handleDateChange}
                required
                header={
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="We need your DOB to verify your qualifications, and
										deposit your wages and superannuation"
                  />
                }
              /> */}

              <div className="row">
                <FormDropdown
                  label="Country"
                  id="country"
                  className="col-md-5 px-0 px-md-3"
                  required
                  value={this.props.state.country}
                  onChange={this.props.handleFormFieldChange}
                >
                  <option value="" hidden>Please Choose</option>
                  {Country.getAllCountries().map((country) => {
                    return <option value={country.isoCode}>{country.name}</option>;
                  })}
                  </FormDropdown>

                <FormDropdown
                  label="Region"
                  id="region"
                  className="col-md-4 px-0 px-md-3"
                  value={this.props.state.region}
                  onChange={this.changeRegion}
                  required
                >
                  <option value="" hidden>Please Choose</option>
                  {State.getStatesOfCountry(this.props.state.country)?.map((state) => {
                    return <option value={state.isoCode}>{state.name}</option>;
                  })}
                </FormDropdown>

                <FormDropdown
                  label="City"
                  id="city"
                  className="col-md-3 px-0 px-md-3"
                  required
                  value={this.props.state.city}
                  onChange={this.props.handleFormFieldChange}
                >
                  <option value="" hidden>Please Choose</option>
                  {this.state.cities_by_state?.map((city) => {
                    return <option value={city.name}>{city.name}</option>;
                  })}
                  </FormDropdown>
              </div>

              <FormField
                label="Address Line 1"
                id = "address_line1"
              //  id="address_line1"
                value={this.props.state.address_line1}
                onChange={this.props.handleFormFieldChange}
                placeholder = {this.props.placeholder}
                required
              />

              <FormField
                label="Address Line 2"
                id = "address_line2"
              //  id="address_line2"
                value={this.props.state.address_line2}
                onChange={this.props.handleFormFieldChange}
                placeholder = {this.props.placeholder}
              //  placeholder="Address Line 2"
                />

              <div className="row">
                <FormField
                  label="Suburb (AUS Only)"
                  id="suburb"
                  className="col-md-5 px-0 px-md-3"
                //  required
                  value={this.props.state.suburb}
                  onChange={this.props.handleFormFieldChange}
                  placeholder="Suburb"
                />

                <FormDropdown
                  label="State (AUS Only)"
                  id="state"
                  className="col-md-4 px-0 px-md-3"
                  value={this.props.state.state}
                  onChange={this.props.handleFormFieldChange}
                  // placeholder="State"
                //  required
                >
                  <option value="" hidden>Please Choose</option>
                  {states.map((state) => {
                    return <option key={state}>{state}</option>;
                  })}
                </FormDropdown>

                <FormField
                  label="Postcode (AUS Only)"
                  id="postcode"
                  className="col-md-3 px-0 px-md-3"
                //  required
                  value={this.props.state.postcode}
                  onChange={this.props.handleFormFieldChange}
                  placeholder="Postal code"
                />
              </div>

              <FormMultiSelect
                className='d-none'
                label="Preferred Work Locations"
                id="prefered_work_location"
                onChange={this.handleLocationDDL}
                defaultValue={this.state.default_work_location}
                options={cities}
                maxMenuHeight={116}
                isSearchable
                isMulti
                // required
                placeholder="Choose cities where you'd like to work"
              />

              <FormDatePicker
                label="Date of Birth"
                id="date_of_birth"
                selected={this.props.state.date_of_birth}
                // placeholderText={new Date()
                //   .toLocaleDateString()
                //   .split(/\//)
                //   .join("-")}
                placeholderText="Please Select"
                showYearDropdown
                showMonthDropdown
                isClearable
                showPopperArrow={false}
                maxDate={addDays(new Date(), 0)}
                dropdownMode="select"
                dateFormatCalendar="MMMM"
                dateFormat="dd-MM-yyyy"
                yearDropdownItemNumber={10}
                scrollableYearDropdown
                onChange={this.props.handleDateChange}
                required
                header={
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="We need your DOB to verify your qualifications, and
										deposit your wages and superannuation"
                  />
                }
              />

              {/* whereby link 
              <FormField
                label="Whereby Link (optional)"
                id="whereby_link"
                onChange={this.props.handleFormFieldChange}
                value={this.props.state.whereby_link}
                title="Please match url format with https://whereby.com/example"
                pattern="^https:\/\/?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
                placeholder="Insert your whereby.com link here e.g.: https://whereby.com/example"
                /> */}
            </div>
          </div>
        </div>

        <Modal
          className="confirm-number-modal"
          header="MOBILE VERIFICATION"
          show={this.state.showConfirmNumber}
          onClose={() => this.setState({ showConfirmNumber: false })}
        >
          <h5 className="contact_numberConfirmation1">
            Is {this.props.state.contact_number} your number?
          </h5>
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton type="button" onClick={this.handleChangeNumber}>
                No and Change
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton type="button" onClick={this.handleRequestOTP}>
                Yes and Proceed
              </ConfirmButton>
            </div>
          </div>
        </Modal>

        <Modal
          className="confirm-number-modal"
          header="Confirmation Code"
          show={this.state.showPopup}
          onClose={this.handleCancelCode}
        >
          <FormField
            type="number"
            id="verifycode"
            name="verifycode"
            className="px-5"
            placeholder="Enter the code sent to your mobile phone"
            autoFocus
          />
          <div className="row m-0">
            <div className="col-md-6">
              <CancelButton type="button" onClick={this.handleCancelCode}>
                Cancel
              </CancelButton>
            </div>
            <div className="col-md-6 padding-for-mobile">
              <ConfirmButton type="button" onClick={this.handleConfirmCode}>
                Verify
              </ConfirmButton>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}


//Map root state to this component
const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(PersonalForm2);
// export default PersonalForm2;
